import React from "react";

import { Context } from "@reactivated";

// Replace direct imports of Context from @reactivated with this
// to avoid destroying Storybook
export const ReactivatedContext = React.createContext<
    React.ComponentProps<typeof Context>["value"]
>({
    template_name: "",
    messages: [],
    csrf_token: "",
    request: {
        path: "",
        url: "",
        csp_nonce: null,
    },
    STATIC_URL: "",
    i18n: {
        language: {
            code: "en-us",
            vernacular_name: "English",
            translated_name: "English",
            dir: "ltr",
        },
        catalog: [],
        formats: [],
    },
    meta_tags: {
        meta_tags: {
            _type: "StreamField",
            _variant: "thelabui.MetaTagSettings.meta_tags",
            value: [],
        },
    },
    core_assets: {
        logo: "",
        logo_inverted: "",
        apple_touch_icon: "",
        favicon_png: "",
        favicon_ico: "",
        favicon_svg: "",
    },
    LOCALE: "en_US",
    SENTRY_DSN: null,
    CI_COMMIT_REF_SLUG: "",
    CI_COMMIT_SHA: "",
    GOOGLE_MAPS_V3_APIKEY: null,
    DESIGN_VERSION: "v2026",
    DISTANCE_UNIT: "mi",
    STATES: {},
    ENVIRONMENT: "development",
    root_page: {
        title: "",
        seo_title: "",
        url: "",
    },
    nav: [],
    footer: null,
    countries: [],
    wagtail_links: {
        search: "",
        find_dealer: "",
        privacy_policy: "",
    },
    header_content: null,
    favorites_page_url: null,
    suggested_locale: null,
    setValue: () => {},
});
